import { render, staticRenderFns } from "./CommitInfo.vue?vue&type=template&id=1d17254a&scoped=true"
import script from "./CommitInfo.vue?vue&type=script&lang=js"
export * from "./CommitInfo.vue?vue&type=script&lang=js"
import style0 from "./CommitInfo.vue?vue&type=style&index=0&id=1d17254a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17254a",
  null
  
)

export default component.exports